module.exports = __webpack_public_path__ + "static/media/iphone-mockup.f46b128c.png";